import { z } from 'zod';

export const deployResponseSchema = z.object({
  success: z.boolean(),
  git: z.string().optional(),
  install: z.string().optional(),
  build: z.string().optional(),
  error: z.string().optional(),
  timestamp: z.string(),
});

export type IDeployResponse = z.infer<typeof deployResponseSchema>;
